import React, { useState, useEffect } from 'react'
import { Box, DataTable, Text, Spinner, Anchor, Button } from 'grommet'
import { Add } from 'grommet-icons'
import { API } from '../../libs/amplifyAPI'
import AddRepository from '../../components/Repositories/addRepository'

const Repositories = () => {
  const [repositories, setRepositories] = useState([])
  const [loading, setLoading] = useState(false)
  const [showAddModal, setShowAddModal] = useState(false)

  const fetchRepositories = () => {
    setLoading(true)
    API.get('LocmanUI', 'repositories/files')
      .then(data => {
        data.forEach(repo => {
          repo.owner = repo.owner || 'qlik-trial',
          repo.defaultBranch = repo.defaultBranch || 'master'
        })
        setRepositories(data)
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchRepositories()
  }, [])

  const columns = [
    {
      property: 'name',
      header: <Text weight='bold'>Name</Text>,
      search: true,
      // primary: true,
    },
    {
      property: 'description',
      header: <Text weight='bold'>Description</Text>,
    },
    {
      property: 'category',
      header: <Text weight='bold'>Category</Text>,
      search: true,
    },
    {
      property: 'owner',
      header: <Text weight='bold'>Owner</Text>,
      search: true,
    },
    {
      property: 'defaultBranch',
      header: <Text weight='bold'>Default Branch</Text>,
      search: true,
    },
    {
      property: 'files',
      header: <Text weight='bold'>Files</Text>,
      search: true,
      render: datum => (
        <Box gap='xxsmall'>
          {Array.isArray(datum.files) && datum.files.length > 0 ? (
            datum.files.map((file, index) => {
              const githubUrl = `https://github.com/${datum.owner}/${datum.name}/blob/${datum.defaultBranch}/${file}`
              return (
                <Anchor 
                  key={index} 
                  href={githubUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  size='small'
                >
                  {file}
                </Anchor>
              )
            })
          ) : (
            <Text size='small'>-</Text>
          )}
        </Box>
      ),
    },
  ]

  if (loading) {
    return (
      <Box align='center' justify='center' pad='large'>
        <Spinner size='large' />
      </Box>
    )
  }

  return (
    <Box pad='medium' gap='small'>
      <Box direction='row' justify='between' align='center'>
        <Text size='large' weight='bold'>Repositories</Text>
      </Box>
      <Box overflow='auto'>
        <DataTable
          columns={columns}
          data={repositories}
          border={{
            header: {
              side: 'bottom',
              size: 'small',
            },
            body: {
              side: 'bottom',
              size: 'xsmall',
            },
          }}
          background={{
            header: 'light-2',
            body: ['white', 'light-1'],
          }}
          paginate={true}
          step={20}
          primaryKey='repoId'
        />
      </Box>
      <Box align='center' margin={{ top: 'small' }}>
        <Button 
          label="Add Repo" 
          icon={<Add />} 
          primary 
          onClick={() => setShowAddModal(true)}
        />
      </Box>
      {showAddModal && (
        <AddRepository 
          onClose={() => setShowAddModal(false)}
          onSuccess={fetchRepositories}
        />
      )}
    </Box>
  )
}

export default Repositories
